import { connect } from "react-redux";
import MemberProjectHub from "../components/members/MemberProjectHub";
import { redirectToHub } from "../actions/members";

// Connects the read-only Project Hub ops view to the selected member (GX-7302).
// Rendered as its own member-level route/tab (sibling of Details), so it draws
// member + adminUser from redux the same way MemberDetails does.
const mapStateToProps = (state) => ({
  member: state.selectedMember,
  adminUser: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  onOpenHub: (userID, email) => dispatch(redirectToHub(userID, email)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MemberProjectHub);
